import { alertConstants } from "../_constants/alert.constants";

function addAlert(title, message, alertType = "info") {
  return {
    type: alertConstants.ADD_ALERT,
    payload: { type: alertType, title: title, message: message },
  };
}

function removeAlert() {
  return {
    type: alertConstants.REMOVE_ALERT,
    payload: null,
  };
}

export const alertActions = {
  addAlert,
  removeAlert,
};
